<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:processFlag="{ row }">
        <el-tag
          size="mini"
          :type="
            row.processFlag === 'Y'
              ? 'success'
              : row.processFlag === 'F'
              ? 'warning'
              : row.processFlag === 'K'
              ? 'info'
              : row.processFlag === 'D'
              ? 'danger'
              : ''
          "
        >
          {{ row.v_processFlag }}
        </el-tag>
      </template>

      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-show="
            allow('D') && row.processFlag !== 'D' && row.processFlag !== 'N'
          "
        >
          <i class="el-icon-delete tool-btn" @click="del(row)"></i>
        </el-tooltip>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    del({ fileCode }) {
      this.$confirm(
        this.$l('INDEX.tips_deleting_this_file_record') ||
          '删除该文件记录会同步删除导入数据，是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .ecomAmzFileDelApi({ listFileCode: [fileCode] })
          .catch(() => null)
        this.loadingClose()
        const { status } = res || {}
        if (status !== 200) {
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
  },
}
</script>
